<template>

  <section class="row">
    <div
        v-if="internalPosts.length"
        class="col col-12 col-md-6 col-lg-6 col-xl-4 item"
        v-for="post in internalPosts"
    >
      <div class="item-inner">
        <div v-if="post.category" v-html="post.category.name" class="category" v-bind:class="'cat-label cat-label-'+post.category.slug" :style="[post.category.acf.category_color ? {'background-color': post.category.acf.category_color} : {}]"></div>
        <div v-if="post.hasOwnProperty('rating') && post.rating > 0" v-html="post.rating+'/5'" class="rating" v-bind:class="'rating-label'"></div>
        <div v-else v-html="'k.B.'" class="rating" v-bind:class="'rating-label'"></div>
        <div class="item-image-container">
          <router-link :to="wpApi.stripBaseUrl(post['link'])">
            <img
                v-if="post['acf']['config_disable_header'] !== true && post['acf']['teaser_video_youtube_id']"
                alt="Video"
                class="video-icon"
                src="/img/ic_video.svg"
            />
            <img
                v-if="post['acf']['teaser_image_960_720'] || post['acf']['teaser_image_600_290']"
                :alt="post['acf']['teaser_image_alt_text']"
                class="item-image item-image-290 w-100"
                :src="wpApi.stripHost(post['acf']['teaser_image_600_290'] ? post['acf']['teaser_image_600_290'] : post['acf']['teaser_image_960_720'])"
            />
            <img
                v-if="post['acf']['teaser_image_960_720'] || post['acf']['teaser_image_440_218']"
                :alt="post['acf']['teaser_image_alt_text']"
                class="item-image item-image-218 w-100"
                :src="wpApi.stripHost(post['acf']['teaser_image_440_218'] ? post['acf']['teaser_image_440_218'] : post['acf']['teaser_image_960_720'])"
            />
            <img
                v-if="post['acf']['teaser_image_960_720'] || post['acf']['teaser_image_386_181']"
                :alt="post['acf']['teaser_image_alt_text']"
                class="item-image item-image-181 w-100"
                :src="wpApi.stripHost(post['acf']['teaser_image_386_181'] ? post['acf']['teaser_image_386_181'] : post['acf']['teaser_image_960_720'])"
            />
            <img
                v-if="post['acf']['teaser_image_960_720'] || post['acf']['teaser_image_435_145']"
                :alt="post['acf']['teaser_image_alt_text']"
                class="item-image item-image-145 w-100"
                :src="wpApi.stripHost(post['acf']['teaser_image_435_145'] ? post['acf']['teaser_image_435_145'] : post['acf']['teaser_image_960_720'])"
            />
            <img
                v-if="post['acf']['teaser_image_960_720'] || post['acf']['teaser_image_719_135']"
                :alt="post['acf']['teaser_image_alt_text']"
                class="item-image item-image-135 w-100"
                :src="wpApi.stripHost(post['acf']['teaser_image_719_135'] ? post['acf']['teaser_image_719_135'] : post['acf']['teaser_image_960_720'])"
            />
            <img
                v-if="post['acf']['teaser_image_960_720'] || post['acf']['teaser_image_339_125']"
                :alt="post['acf']['teaser_image_alt_text']"
                class="item-image item-image-125 w-100"
                :src="wpApi.stripHost(post['acf']['teaser_image_339_125'] ? post['acf']['teaser_image_339_125'] : post['acf']['teaser_image_960_720'])"
            />
          </router-link>
        </div>
        <div class="item-card">
          <div class="item-card-inner">
            <router-link :to="wpApi.stripBaseUrl(post['link'])">
              <h4
                  class="item-heading"
                  v-html="post['acf']['teaser_title']"
              ></h4>
              <p
                  class="item-text"
                  v-html="post['acf']['teaser_copy']"
              ></p>
              <btn class="btn btn-pink-white ani-btn-hover-scale-bounce">mehr erfahren</btn>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isLoaded && internalPosts.length === 0" class="col col-12 text-center text-center text-white my-4">
      <p>Keine Einträge gefunden!</p>
    </div>
  </section>

</template>

<script>

// console.log('Teaser');

import wpApi from '../services/wpApi';

export default {
  created(){

    this.loadPosts();
  },
  data(){
    return {
      isLoaded : false,
      isLoading : false,
      internalPosts : [],
      wpApi,
      updateExcludeParam: true,
      loadNotTop: false
    };
  },
  watch: {
    // This would be called anytime the value of page changes
    pageFilterParam(newValue, oldValue) {
      if(this.loadNotTop){
        oldValue = -1;
        this.loadNotTop = false;
      }
      if(newValue > oldValue){
        this.getPosts();
      }
    },

    // This would be called anytime the value of categoriesFilterParam changes
    categoriesFilterParam(newValue, oldValue) {
      if(this.loadNotTop) this.loadNotTop = false;
      if (this.teaserFilterParams.hasOwnProperty('filter[meta_key]') && this.teaserFilterParams['filter[meta_key]'] == 'top' && this.teaserFilterParams.hasOwnProperty('filter[meta_value]') && this.teaserFilterParams['filter[meta_value]'] == '0') {
        this.teaserFilterParams['filter[meta_value]'] = '1';
      }
      this.loadPosts();
    }
  },
  props : {
    'teaserFilterParams' : {
      default : {},
      type : Object,
    },
    'teaserHeading' : {
      default : '',
      type : String,
    },
    'teaserId' : {
      default : '',
      type : String,
    },
    'categories' : {
      default : ()=>{
        return [];
      },
      type : Array,
    },
    'pageFilterParam' : {
      default : 1,
      type : Number,
    },
    'categoriesFilterParam' : {
      default : ()=>{
        return [];
      },
      type : Array,
    },
    'orderByParam' : {
      default : '',
      type : String,
    },
  },
  methods : {
    loadPosts(){

      this.internalPosts = [];
      this.isLoaded = false;
      this.isLoading = false;
      this.updateExcludeParam = true;
      this.teaserFilterParams['exclude'] = new Array();
      this.getPosts();
    },
    showLoadMoreButton(show) {
      this.$emit('showLoadMore', {
        "orderby" : this.orderByParam,
        "show" : show
      });
    },
    unsetLoadTopParam(){
      if(this.teaserFilterParams.hasOwnProperty('filter[meta_key]') && this.teaserFilterParams['filter[meta_key]'] == 'top'  && this.teaserFilterParams.hasOwnProperty('filter[meta_value]') && this.teaserFilterParams['filter[meta_value]'] == '1'){
        this.teaserFilterParams['filter[meta_value]'] = '0';
      }
    },
    getPosts(){
      let url = wpApi.host + wpApi.baseUrl + '/wp-json/wp/v2/posts',
          queryStr = [],
          isLoadingTop = this.orderByParam == 'top',
          perPage = null;

      let topPosts = isLoadingTop == true && this.teaserFilterParams.hasOwnProperty('filter[meta_key]') && this.teaserFilterParams['filter[meta_key]'] == 'top' && this.teaserFilterParams.hasOwnProperty('filter[meta_value]') && this.teaserFilterParams['filter[meta_value]'] == '1';

      if (false === (Object.keys(this.teaserFilterParams).length === 0 && this.teaserFilterParams.constructor === Object)) {
        for (let q in this.teaserFilterParams){
          if (this.teaserFilterParams.hasOwnProperty(q)) {
            let paramValue = this.teaserFilterParams[q];
            if(q == 'per_page'){
              perPage = paramValue;
            }
            else if(q == 'per_page_more'){
              q = 'per_page';
              perPage = paramValue;
              delete this.teaserFilterParams['per_page_more'];
            } else if(q == 'categories' && paramValue.length === 0){
              continue;
            }
            queryStr.push(q + "=" + encodeURIComponent(paramValue));
          }
        }
      }

      url += '?visibility_published=1&'+queryStr.join("&");
      return wpApi.http.get(url)
          .then( response => {

            if (Array.isArray(response.data) === false || response.data.length === 0) {
              this.isFinished = true;
              this.showLoadMoreButton(false);
              this.isLoaded = true;
              this.isLoading = false;
              return;
            }

            let showLoadMoreButton = perPage == null || response.data.length === perPage
            if(showLoadMoreButton === true && 'x-wp-totalpages' in response.headers) {
              const url = new URL('https://'+window.location.host+'/'+url);
              const params = url.searchParams;
              let totalPages = parseInt(response.headers['x-wp-totalpages']);
              let pageValue = params.has('page') && params.get('page') !== '' ?  parseInt(params.get('page')) : 1;

              showLoadMoreButton = pageValue < totalPages;
              console.log(pageValue +'<'+ totalPages);
            }
            this.showLoadMoreButton(showLoadMoreButton);

            response.data = response.data.filter(post => post['acf']['visibility_published']);

            if(this.categories.length){
              response.data.forEach(post => {
                if(post.hasOwnProperty('categories') && post.categories.length){
                  this.categories.forEach(category => {
                    if(post.categories.indexOf(category.id) !== -1){
                      post.category = category;
                      return;
                    }
                  });
                }
              });
            }

            this.isLoaded = true;
            this.isLoading = false;

            this.$root.events.$emit('loaded', this.teaserId);

            response.data.forEach(post => {
              this.internalPosts.push(post);
              if(this.updateExcludeParam){
                this.teaserFilterParams['exclude'].push(post.id);
              }
              if(topPosts == true && post.hasOwnProperty('acf')
                  && post['acf'].hasOwnProperty('top')
                  && post['acf']['top'] == false){
                this.unsetLoadTopParam();
              }
            });

            if(topPosts == true && response.data.length < this.teaserFilterParams['per_page']){
              this.teaserFilterParams['per_page_more'] = this.teaserFilterParams['per_page'] - response.data.length;
              this.unsetLoadTopParam();
              this.updateExcludeParam = true;
              this.teaserFilterParams['exclude'] = new Array();
              this.teaserFilterParams['page'] = 1;
              this.loadNotTop = true;
              this.getPosts();
            }else{
              if(this.loadNotTop) this.teaserFilterParams['page'] = 0;
              this.updateExcludeParam = false;
            }

            console.log(this.internalPosts);
            console.log(this.teaserFilterParams['per_page']);
            console.log(response.data.length);

            window.setTimeout(()=>{
              $('.item-heading').dotdotdot({
                ellipsis : '\u00A0\u2026',
              });
              $('.item-text').dotdotdot({
                ellipsis : '\u00A0\u2026',
              });
            }, 125);
          })
          .catch(error => {
            console.log('error', error);
          });
    },
  },
}

</script>

<style lang="scss">

@import '../../css/variables';

.tabbed-teaser {
  .item {
    opacity: 1;
    transform: translateX(0) !important;
    transition: opacity 800ms, transform 800ms;
  }
  &.tabbed-teaser-pink-white .teaser-inner{
    .item-card-inner .btn{
      background-color: $color-nochvielvor-pink;
      border-color: $color-nochvielvor-pink;
      color: $color-nochvielvor-white;
    }
  }
  &.tabbed-teaser-white-pink .teaser-inner{
    .item {
      .item-card {
        background-color: $color-nochvielvor-pink;
        .item-heading {
          color: $color-nochvielvor-white;
        }
        .item-text {
          color: $color-nochvielvor-white;
        }
      }
    }
    .teaser-inner-loading {
      .item {
        background: transparentize($color-nochvielvor-black, .9);
        .item-card {
          background: transparentize($color-nochvielvor-black, .9);
        }
      }
    }
  }
  &.tabbed-teaser-transparent-pink .teaser-inner{
    .item {
      .item-card {
        background-color: $color-nochvielvor-pink;
        .item-heading {
          color: $color-nochvielvor-white;
        }
        .item-text {
          color: $color-nochvielvor-white;
        }
      }
    }
  }
  &.tabbed-teaser-transparent-white-pink .teaser-inner{
    .item {
      .item-card {
        background-color: $color-nochvielvor-black;
        .item-heading {
          color: $color-nochvielvor-white;
        }
        .item-text {
          color: $color-nochvielvor-white;
        }
      }
    }
    .teaser-inner-loading {
      .item {
        background: transparentize($color-nochvielvor-black, .9);
        .item-card {
          background: transparentize($color-nochvielvor-black, .9);
        }
      }
    }
  }
  .teaser-inner-loading {
    padding: 2.5rem 1.5rem 4rem 1.5rem;
    @media screen and (min-width: 1200px) {
      padding: 2.5rem * $factor-1200 1.5rem * $factor-1200 4rem * $factor-1200 1.5rem * $factor-1200;
    }
    @media screen and (min-width: 1440px) {
      padding: 2.5rem * $factor-1440 1.5rem * $factor-1440 4rem * $factor-1440 1.5rem * $factor-1440;
    }
    @media screen and (min-width: 1920px) {
      padding: 2.5rem * $factor-1920 1.5rem * $factor-1920 4rem * $factor-1920 1.5rem * $factor-1920;
    }
    @media screen and (min-width: 2400px) {
      padding: 2.5rem * $factor-2400 1.5rem * $factor-2400 4rem * $factor-2400 1.5rem * $factor-2400;
    }
    &.teaser-inner-blank {
      padding-top: 4rem;
      @media screen and (min-width: 1200px) {
        padding-top: 4rem * $factor-1200;
      }
      @media screen and (min-width: 1440px) {
        padding-top: 4rem * $factor-1440;
      }
      @media screen and (min-width: 1920px) {
        padding-top: 4rem * $factor-1920;
      }
      @media screen and (min-width: 2400px) {
        padding-top: 4rem * $factor-2400;
      }
    }
    .item {
      display: none;
      min-height: 2rem;
      background: transparentize($color-nochvielvor-white, .9);
      opacity: 1;
      transform: translateX(0) !important;
      transition: opacity 800ms, transform 800ms;
      @media screen and (min-width: 1200px) {
        min-height: 2rem * $factor-1200;
      }
      @media screen and (min-width: 1440px) {
        min-height: 2rem * $factor-1440;
      }
      @media screen and (min-width: 1920px) {
        min-height: 2rem * $factor-1920;
      }
      @media screen and (min-width: 2400px) {
        min-height: 2rem * $factor-2400;
      }
      .item-card {
        background: transparentize($color-nochvielvor-white, .9);
      }
    }
  }
  .container-fluid .row .col {
    @for $i from 1 through 20 {
      &:nth-child(#{$i}) {
        .item {
          transition-delay: #{$i * 200}ms;
        }
      }
    }
    &:nth-child(even) {
      .item {
        transform: translateX(100%);
      }
    }
    &:nth-child(odd) {
      .item {
        transform: translateX(-100%);
      }
    }
  }

  .item {
    padding-bottom: 24px;
    @media screen and (min-width: 768px) {
      padding-bottom:30px;
    }
    .item-inner{
      background-color: $color-nochvielvor-white;
      height: 100%;
      flex-flow: column;
      display: flex;
      position:relative;
      .video-icon{
        position: absolute;
        left: 50%;
        width: 58px;
        height: 58px;
        top:50%;
        transform: translate(-50%, -50%);
      }
      .item-image-container{
        max-height: 125px;
        overflow: hidden;
        position: relative;
        .item-image-125{
          display: none;
        }
        .item-image-145{
          display: none;
        }
        .item-image-181{
          display: none;
        }
        .item-image-218{
          display: none;
        }
        .item-image-290{
          display: none;
        }
        @media screen and (min-width: 768px) {
          .item-image-135{
            display: none;
          }
          .item-image-125{
            display: block;
          }
        }
        @media screen and (min-width: 992px) {
          max-height: 145px;
          .item-image-125{
            display: none;
          }
          .item-image-145{
            display: block;
          }
        }
        @media screen and (min-width: 1200px) {
          max-height: 145px * $factor-1200;
          .item-image-145{
            display: none;
          }
          .item-image-181{
            display: block;
          }
        }
        @media screen and (min-width: 1440px) {
          max-height: 145px * $factor-1440;
          .item-image-181{
            display: none;
          }
          .item-image-218{
            display: block;
          }
        }
        @media screen and (min-width: 1920px) {
          max-height: 145px * $factor-1920;
          .item-image-218{
            display: none;
          }
          .item-image-290{
            display: block;
          }
        }
        @media screen and (min-width: 2400px) {
          max-height: 145px * $factor-2400;
        }
      }
    }
    .item-card {
      transition: transform 400ms;
      will-change: transform;
      flex: 1 1 auto;
      .item-card-inner {
        position: relative;
        text-align: center;
        height: 100%;
        padding: 24px 16px 16px;
        transition: transform 400ms;
        will-change: transform;
        @media screen and (min-width: 768px) {
          padding:20px 22px 46px;
        }
        @media screen and (min-width: 1200px) {
          padding:20px * $factor-1200 22px * $factor-1200 46px * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
          padding:20px * $factor-1200 22px * $factor-1440 46px * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
          padding:20px * $factor-1200 22px * $factor-1920 46px * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
          padding:20px * $factor-1200 22px * $factor-2400 46px * $factor-2400;
        }
        .btn{
          @media screen and (min-width: 768px) {
            position: absolute;
            bottom: 0;
            transform: translate(-50%, -50%);
          }
        }

      }
      .item-heading {
        margin-bottom: 14px;
        color: $color-nochvielvor-black;
        font-size: 18px;
        font-weight: bold;
        line-height: 1.2;
        text-transform: uppercase;
        @media screen and (min-width: 768px) {
          margin-bottom: 12px;
        }
        @media screen and (min-width: 1200px) {
          font-size: 15px * $factor-1200;
          margin-bottom: 12px * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
          font-size: 15px * $factor-1440;
          margin-bottom: 12px * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
          font-size: 15px * $factor-1920;
          margin-bottom: 12px * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
          font-size: 15px * $factor-2400;
          margin-bottom: 12px * $factor-2400;
        }
      }
      .item-text {
        //max-height: 14px * 6;
        color: $color-nochvielvor-black;
        font-size: 12px;
        line-height: 1.2;
        margin-bottom: 14px;
        @media screen and (min-width: 768px) {
          font-size: 12px;
          margin-bottom: 22px;
        }
        @media screen and (min-width: 1200px) {
          font-size: 12px * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
          font-size: 12px * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
          font-size: 12px * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
          font-size: 12px * $factor-2400;
        }
      }
    }
    .cat-label {
      background-color: $color-nochvielvor-black;
      color: $color-nochvielvor-white;
      text-transform: uppercase;
      font-weight: bold;
      position: absolute;
      padding: 5px;
      z-index: 1;
      &.cat-label-hiv-im-alltag{
        background-color: $color-nochvielvor-blue;
      }
      &.cat-label-zukunft-mit-hiv{
        background-color: rgba(231, 62, 80, 0.8);
      }
      &.cat-label-hiv-im-dialog{
        background-color: $color-nochvielvor-gray;
      }
    }
    .rating-label{
      background-color: $color-nochvielvor-white;
      color: $color-nochvielvor-pink;
      text-transform: uppercase;
      font-weight: bold;
      position: absolute;
      background-color: #fff;
      background-image: url(/img/ic_star.svg);
      background-repeat: no-repeat;
      padding:7px 7px 7px 27px;
      right: 0;
      background-position: 7px 7px;
      z-index: 1;
    }
  }
}

</style>


// WEBPACK FOOTER //
// public/js/components/TeaserWide.vue